import React from 'react'
import { LntBadge } from '@app/components/base'

import { isNullable } from '@app/utils'

import { COUNT_STATUS } from '@app/constants/countStatus'

import { getColor } from './utils'

import styles from './styles.module.scss'

import type { ObjectValuesType } from '@app/types'

export const CountWithStatusRender: React.FC<{
  status?: ObjectValuesType<typeof COUNT_STATUS> | null
  count: number
}> = ({ status, count }) => {
  if (isNullable(status)) return null

  const color = getColor(status)

  return (
    <>
      <LntBadge
        color={ color }
        className={ styles.countWithStatus__badge }
      />
      { count }
    </>
  )
}
